const state = {
  menu: [],
  productInfo: {},
  config: {},
  apiLoading: false,
  pageLoading: false,
}

const mutations = {
  SET_MENU: (state, menu) => {
    state.menu = menu
  },
  SET_PRODUCT_INFO: (state, productInfo) => {
    state.productInfo = productInfo
  },
  SET_CONFIG: (state, config) => {
    state.config = config
  },
  SET_API_LOADING: (state, loading) => {
    state.apiLoading = loading
  },
  SET_PAGE_LOADING: (state, loading) => {
    state.pageLoading = loading
  },
}

const actions = {
  setProductInfo({ commit }, productInfo) {
    commit('SET_PRODUCT_INFO', productInfo)
  },
  setMenu({ commit }, menu) {
    commit('SET_MENU', menu)
  },
  setConfig({ commit }, config) {
    commit('SET_CONFIG', config)
  },
  setApiLoading({ commit }, loading) {
    commit('SET_API_LOADING', loading)
  },
  startLoading({ commit }) {
    commit('SET_PAGE_LOADING', true)
  },
  finishLoading({ commit }) {
    commit('SET_PAGE_LOADING', false)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
